// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"744":"ee01f157","824":"c93d688f"}[chunkId] + ".chunk.js";
};